var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPunishDissenters4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 3C48.3594 3 60 14.6407 60 29C60 43.3594 48.3594 55 34 55C19.6406 55 8 43.3594 8 29C8 14.6407 19.6406 3 34 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3809 14.506L27.157 25.9382L16.541 25.3592L25.618 32.2017L21.8274 42.9204L30.6614 35.717L38.9343 42.9204L35.3174 31.6261L44.2207 25.3592L33.1513 25.5827L30.3809 14.506Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3809 14.506L27.157 25.9382L16.541 25.3592L25.618 32.2017L21.8274 42.9204L30.6614 35.717L38.9343 42.9204L35.3174 31.6261L44.2207 25.3592L33.1513 25.5827L30.3809 14.506Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12744 52.0295L0.90332 51.3896C1.77252 50.2882 2.58599 49.1521 3.34066 47.9789C4.09506 46.8081 4.82866 45.5601 5.54346 44.2375L6.75932 44.4269L6.43652 50.9255L8.69519 50.7655L8.3433 51.6481L6.34318 51.6803L6.19918 54.5894L4.99919 55.3093C5.14839 54.1975 5.22331 53.0053 5.22331 51.7415H4.5033C3.60183 51.7415 2.47397 51.8375 1.12744 52.0295ZM5.51131 45.5816L1.97253 50.9255H5.22331L5.51131 45.5816Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8539 46.5979C12.9722 46.5979 13.879 47.6093 13.879 48.8565C13.879 50.1042 12.9722 51.1151 11.8539 51.1151C10.7355 51.1151 9.82886 50.1042 9.82886 48.8565C9.82886 47.6093 10.7355 46.5979 11.8539 46.5979Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8539 46.5979C12.9722 46.5979 13.879 47.6093 13.879 48.8565C13.879 50.1042 12.9722 51.1151 11.8539 51.1151C10.7355 51.1151 9.82886 50.1042 9.82886 48.8565C9.82886 47.6093 10.7355 46.5979 11.8539 46.5979Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8941 54.5524H7.76611C7.76611 52.4017 9.61439 50.6578 11.8941 50.6578C14.174 50.6578 16.0221 52.4017 16.0221 54.5524H11.8941Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8941 54.5524H7.76611C7.76611 52.4017 9.61439 50.6578 11.8941 50.6578C14.174 50.6578 16.0221 52.4017 16.0221 54.5524H11.8941Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-532 -830)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunishDissenters4);
export default __webpack_public_path__ + "static/media/punish_dissenters4.d4ecb619d7d7dd351b5a020a89836394.svg";
export { ForwardRef as ReactComponent };